export type $Object = { [key: string]: any };

export function enumKeys(enumType: $Object) {
  return Object.values(enumType).filter((o) => typeof o == 'string');
}